import { createReducer } from '@common/redux-utils';
import { PaymentEditActionType, SetPaymentEditLoadingAction, SetPaymentEditDetailAction } from './payment-edit.actions';
import { ContractPaymentDetailViewModel } from '@models/Payment';

export interface PaymentEditState {
  readonly isLoadingPayment: boolean;
  readonly contractPaymentDetail?: ContractPaymentDetailViewModel;
}

export const initPaymentEditState: PaymentEditState = {
  isLoadingPayment: false
};

export function handleSetPaymentEditLoading(
  state: PaymentEditState,
  action: SetPaymentEditLoadingAction
): PaymentEditState {
  return {
    ...state,
    isLoadingPayment: action.isLoading
  };
}

export function handleSetPaymentEditDetail(
  state: PaymentEditState,
  action: SetPaymentEditDetailAction
): PaymentEditState {
  return {
    ...state,
    contractPaymentDetail: action.paymentEditDetail
  };
}

export const PaymentEditReducer = createReducer<PaymentEditState, PaymentEditActionType>(initPaymentEditState, {
  [PaymentEditActionType.SetPaymentEditLoading]: handleSetPaymentEditLoading,
  [PaymentEditActionType.SetPaymentEditDetail]: handleSetPaymentEditDetail
});



// WEBPACK FOOTER //
// ./src/contract/_components/payment-edit/payment-edit.reducer.tsx